import { api } from '../lib/api.js';
import { el, render } from '../lib/dom.js';
import { pageHeader, kpiCard, searchField, filterSelect } from '../lib/ui.js';
import { projectsTable } from './projects-table.js';

// ---------------------------------------------------------------------------
// Projects — every project across every organisation. Read-only: projects are
// created and edited in the tenant app; this is where an operator finds one,
// sees which organisation and owner it belongs to, and reads its schedule
// versions and run IDs for support.
// ---------------------------------------------------------------------------

export function projectsView({ navigate }) {
  const state = { search: '', status: '', sort: 'updatedAt:desc' };
  const kpiSlot = el('div', { class: 'kpi-row' });
  const tableSlot = el('div', {});

  let table = null;
  function buildTable() {
    const [sortBy, sortDir] = state.sort.split(':');
    table = projectsTable({
      showOrg: true,
      navigate,
      emptyText: state.search || state.status ? 'Try a different search or clear the filters.' : 'Projects appear here once organisations create them.',
      fetchPage: (page, pageSize) =>
        api.listProjects({ search: state.search, status: state.status || undefined, sortBy, sortDir, page, pageSize }),
    });
    render(tableSlot, table.root);
  }

  async function loadStats() {
    try {
      const s = await api.projectStats();
      render(
        kpiSlot,
        kpiCard({ label: 'Total projects', value: s.total.toLocaleString(), iconName: 'kpi-projects', tone: 'indigo', meta: 'Across every organisation' }),
        kpiCard({ label: 'Active projects', value: s.active.toLocaleString(), iconName: 'trending-up', tone: 'green', meta: 'Project status Active' }),
        kpiCard({ label: 'New this month', value: s.newLast30Days.toLocaleString(), iconName: 'plus', tone: 'blue', meta: 'Created in the last 30 days' }),
        kpiCard({ label: 'Schedule versions', value: s.versions.toLocaleString(), iconName: 'kpi-ai', tone: 'amber', meta: `${s.versionsLast30Days.toLocaleString()} in the last 30 days` }),
      );
    } catch {
      render(kpiSlot);
    }
  }

  const search = searchField({
    placeholder: 'Search projects or organisations…',
    label: 'Search projects by title or organisation name',
    onSearch: (v) => {
      state.search = v;
      buildTable();
    },
  });

  void loadStats();
  buildTable();

  return el(
    'div',
    { class: 'stack' },
    pageHeader({
      title: 'Projects',
      subtitle: 'Monitor construction projects, schedules and versions across organisations. Read-only — projects are managed in the ConstructMind app.',
    }),
    kpiSlot,
    el(
      'div',
      { class: 'toolbar' },
      search.root,
      filterSelect({
        label: 'Status',
        value: state.status,
        options: [
          { value: '', label: 'All statuses' },
          { value: 'DRAFT', label: 'Draft' },
          { value: 'ACTIVE', label: 'Active' },
          { value: 'BASELINED', label: 'Baselined' },
          { value: 'ARCHIVED', label: 'Archived' },
        ],
        onChange: (v) => {
          state.status = v;
          buildTable();
        },
      }),
      filterSelect({
        label: 'Sort',
        value: state.sort,
        options: [
          { value: 'updatedAt:desc', label: 'Last updated' },
          { value: 'createdAt:desc', label: 'Newest' },
          { value: 'createdAt:asc', label: 'Oldest' },
          { value: 'title:asc', label: 'Title A–Z' },
        ],
        onChange: (v) => {
          state.sort = v;
          buildTable();
        },
      }),
    ),
    tableSlot,
  );
}
